import { Trash2 } from "lucide-react";
import React from "react";

import { IgIconButton, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { fromGqlId } from "@src/api/formatters/shopify";
import NoImage from "@src/images/no_image.png";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

interface ProductListItemProps {
  product: ProductPickerSelectedProduct;
  onRemove: () => void;
  isArchived: boolean;
}

export const ProductListItem = ({
  product,
  onRemove,
  isArchived,
}: ProductListItemProps) => {
  const theme = useTheme();
  return (
    <Grid
      container
      direction={"row"}
      alignItems={"center"}
      wrap={"nowrap"}
      marginBottom={"15px"}
      sx={{
        "&:hover .trash-can": {
          opacity: 1,
        },
      }}
    >
      <Grid container direction={"row"} wrap={"nowrap"}>
        <Grid item container alignItems={"center"} width={"fit-content"}>
          <img
            src={product.image || NoImage}
            alt={product.title}
            style={{
              height: "35px",
              width: "35px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        </Grid>
        <Grid item container direction={"column"} marginLeft={"10px"}>
          <IgTypography variant={"h3"} fontWeight={600}>
            {product.title}
          </IgTypography>
          <IgTypography variant={"body2"} color={theme.palette.text.secondary}>
            {fromGqlId(product.id)}
          </IgTypography>
        </Grid>
      </Grid>
      {!isArchived && (
        <Grid item width={"fit-content"}>
          <IgIconButton onClick={onRemove}>
            <Trash2
              size={18}
              className="trash-can"
              color={theme.igIconColors.error}
            />
          </IgIconButton>
        </Grid>
      )}
    </Grid>
  );
};
